// Example questions for the consultant, shared by every surface that offers
// them.
//
// ⚠️ MOVED OUT OF ConsultantChat SO THE APP CAN USE THEM WITHOUT IMPORTING THE
// TERMINAL'S CHAT COMPONENT. The standalone app renders its own chat precisely
// so styling one cannot disturb the other; reaching back into that file for a
// string array would have re-coupled them through the back door.

/**
 * Short and direct. The desktop drawer is usually opened in flow with another
 * tool, so the reader already has context and needs a nudge, not a tour.
 */
export const SUGGESTED_PROMPTS = [
  "What are the top 5 sale barns right now?",
  "Show me the feeder cohort grid for Steers",
  "What did packers pay for fed cattle this week?",
] as const;

/**
 * Five examples for a surface where the reader has NO context.
 *
 * ⚠️ FIVE, NOT TEN, AND THE COUNT IS THE POINT. The first version listed ten and
 * filled nearly the whole phone screen — which undid the reason the examples
 * were moved off the page in the first place. The suggestion pills were removed
 * to make the opening calm; replacing them with a wall of text one tap away is
 * the same weight in a different place.
 *
 * ⚠️ CHOSEN FOR SPREAD, NOT FOR BEING THE BEST FIVE. One each for the sale
 * barns, fed cattle, boxed beef, and a named barn — so a reader learns the
 * SHAPE of what can be asked rather than five variations on one theme. The
 * dropped five were mostly second examples of ground already covered.
 */
export const EXAMPLE_PROMPTS = [
  "Summarize today's feeder market",
  "What are the top 5 sale barns right now?",
  "What did packers pay for fed cattle this week?",
  "Compare Choice vs. Select boxed beef over 30 days",
  "Tell me about Joplin 6-weight steers",
] as const;
